<template>
  <div class="wrap-table">
    <v-data-iterator
      @update:options="
        update({
          page: $event.page,
          itemsPerPage: $event.itemsPerPage,
          sort: $event.sortBy,
          desc: $event.sortDesc
        })
      "
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :server-items-length="total || -1"
      :options.sync="options"
      :items-per-page="pagination.rowsPerPage"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, 100, 200, 500, 1000]
      }"
      :items="items"
      v-if="isMobile && showMobile"
      class="mobile-table"
    >
      <v-progress-linear
        absolute
        indeterminate
        :active="loading"
      ></v-progress-linear>
      <template v-slot:default="props">
        <v-list class="mobile_list" dense>
          <v-list-item
            v-for="(item, index) in props.items"
            :key="item.id"
            :data-test="`entityRow_${index}`"
          >
            <v-checkbox
              :ripple="false"
              hide-details
              v-if="selected.find(i => i.id === item.id)"
              v-model="selected"
              :value="item"
              :value-comparator="valueComparator"
              class="pl-2 pr-4 py-0 ma-0"
            />
            <v-list-item-avatar color="#333" v-else @click="handleSelect(item)">
              <avatar-item style="margin: 0 auto;" :item="item" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="regular16"
                >{{ item.name || item.login || item.objectName }}
              </v-list-item-title>
              <v-list-item-subtitle class="regular14">
                <object-statuses :entity="item" />
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <div>
                <toggle-favorite
                  v-if="item.__typename === 'Object'"
                  :is-add-to-favourite="item.favourite"
                  :id="item.id"
                />

                <v-btn
                  @click="openItem(item)"
                  :data-test="`objectContextMenu_${index}`"
                  slot="activator"
                  icon
                  color="#686868"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
    </v-data-iterator>
    <v-data-table
      v-else
      unselectable="on"
      class="rowHover custom-table app-wrap-p-r"
      :value="selected"
      @input="
        selected = $event;
        $emit('input', $event);
      "
      :expanded.sync="expanded"
      :headers="[...columns, { text: '', value: 'data-table-expand' }]"
      :items="items"
      :server-items-length="total || -1"
      :loading="loading"
      show-select
      :options.sync="options"
      :items-per-page="pagination.rowsPerPage"
      :show-expand="true"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, 100, 200, 500, 1000]
      }"
      @update:options="
        update({
          page: $event.page,
          itemsPerPage: $event.itemsPerPage,
          sort: $event.sortBy,
          desc: $event.sortDesc
        })
      "
    >
      <template v-slot:header.muted>
        <v-icon>mdi-volume-off</v-icon>
      </template>
      <template v-slot:header.deviceBatteryLevel>
        <v-icon>mdi-battery</v-icon>
      </template>
      <template v-slot:header.favourite>
        <v-icon color="#FFD600">mdi-star</v-icon>
      </template>
      <template v-slot:header.deviceResponseStatus>
        <v-icon>mdi-cloud-outline</v-icon>
      </template>
      <template v-slot:header.deviceEmulation>
        <v-icon>mdi-blur</v-icon>
      </template>

      <template
        v-slot:expanded-item="{ headers, item }"
        v-if="$route.fullPath.includes('apps')"
      >
        <td :colspan="headers.length" :style="{ padding: 0 }">
          <NestedTable
            :depth="1"
            @setActive="handlerRow"
            :items="item.nested.map(i => i.object2)"
            :columns="columns"
          />
        </td>
      </template>
      <template v-slot:item="{ item, index, isSelected, isExpanded, select }">
        <v-hover v-slot="{ hover }">
          <tr
            :data-test="`entityRow_${index}`"
            :data-test-name="item.login"
            @click="handlerRow(item)"
            :class="
              $route.params.id === item.id || isSelected ? 'active-row' : ''
            "
          >
            <td v-for="(itemNested, index) in columns" :key="index">
              <template v-if="itemNested.value === 'data-table-select'">
                <v-simple-checkbox
                  class="text-center checkbox"
                  color="primary"
                  width="40px"
                  :ripple="false"
                  v-show="hover || isSelected"
                  :value="isSelected"
                  @input="select($event)"
                />
                <avatar-item
                  v-show="!hover && !isSelected"
                  style="margin: 0 auto;"
                  :item="item"
                />
              </template>
              <template v-if="itemNested.value === 'deviceResponseStatus'">
                <v-icon v-if="item.deviceResponseStatus"
                  >mdi-cloud-outline
                </v-icon>
                <v-icon v-else color="red">mdi-cloud-off-outline</v-icon>
              </template>
              <template v-else-if="itemNested.value === 'deviceBatteryLevel'">
                <battery-state :object="item" size="24px" />
              </template>
              <template v-else-if="itemNested.value === 'status'">
                <span v-if="item.status">Enabled</span>
                <span v-else>Disabled</span>
              </template>
              <template v-else-if="itemNested.value === 'login'">
                <span :data-test-table-item="item.login">{{ item.login }}</span>
              </template>
              <template v-else-if="itemNested.value === 'drivername'">
                <span :data-test-table-schema-name="item.drivername">{{
                  item.drivername
                }}</span>
              </template>
              <template v-else-if="itemNested.value === 'online'">
                <template v-if="item.enabled">
                  <div
                    v-if="item.online === true"
                    style="width: 12px; border-radius: 50%; height: 12px; background: green;"
                  ></div>
                  <div
                    v-else
                    style="width: 12px; height: 12px;border-radius: 50%; background: red;"
                  ></div>
                </template>
                <div
                  v-else
                  style="width: 12px; height: 12px;border-radius: 50%; background: gray;"
                ></div>
              </template>
              <template v-else-if="itemNested.value === 'enabled'">
                <span data-test-table-item-enabled="Enabled" v-if="item.enabled"
                  >Enabled</span
                >
                <span data-test-table-item-enabled="Disabled" v-else
                  >Disabled</span
                >
              </template>
              <template v-else-if="itemNested.value === 'name'">
                <template
                  v-if="
                    $route.fullPath.includes('apps') &&
                      item.nested.length &&
                      item.nested.length > 0
                  "
                >
                  <div
                    class="nameColumn"
                    :data-test-table-item="item.name"
                  >
<!--                    <div class="nestedIndicator"></div>-->
                    {{ truncateString(item.name, 50) }}
                  </div>
                </template>
                <div v-else :data-test-table-item="item.name">{{
                  truncateString(item.name, 50)
                }}</div>
              </template>
              <template v-else-if="itemNested.value === 'objectName'">
                <span :data-test-table-item="item.objectName">{{
                  truncateString(item.objectName, 50)
                }}</span>
              </template>
              <template v-else-if="itemNested.value === 'message'">
                <span :data-test-table-item-message="item.message">{{
                  truncateString(item.message, 50)
                }}</span>
              </template>
              <template v-else-if="itemNested.value === 'favourite'">
                <span :data-test-table-item-favourite="item.favourite">
                  <v-icon color="#FFD600" v-if="item.favourite"
                    >mdi-star</v-icon
                  >
                </span>
              </template>
              <template v-else-if="itemNested.value === 'muted'">
                <span>
                  <v-icon
                    :data-test-table-item-muted="item.muted"
                    v-if="item.muted"
                    >mdi-volume-off</v-icon
                  >
                </span>
              </template>
              <template v-else-if="itemNested.value === 'deviceEmulation'">
                <v-icon v-if="item.deviceEmulation">mdi-blur</v-icon>
              </template>
              <template v-else-if="itemNested.value === 'lastExecutionResult'">
                <template v-if="!item.lastExecutionResult">
                  "n/a"
                </template>
                <template v-else-if="item.lastExecutionResult.id === 'BROKEN'">
                  <span style="color: #D50000">
                    {{ item.lastExecutionResult.title }}
                  </span>
                </template>
                <template v-else>
                  {{ item.lastExecutionResult.title }}
                </template>
              </template>
              <template v-else-if="itemNested.value === 'tags'">
                <v-chip
                  small
                  color="primary"
                  class="mr-2"
                  v-for="chip in item.tags"
                  :key="chip"
                >
                  {{ chip }}
                </v-chip>
              </template>
              <template v-else>
                {{ item[itemNested.value] }}
              </template>
            </td>
            <td v-if="$route.fullPath.includes('apps')">
              <template v-if="item.nested.length > 0">
                <v-btn icon @click.stop.prevent="expandItem(item)">
                  <v-icon v-if="expanded.find(i => i.id === item.id)"
                    >mdi-chevron-up
                  </v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
            </td>
          </tr>
        </v-hover>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AvatarItem from '@/components/appTable/avatarItem';
import { truncateString } from '../../utils/truncate';
import ToggleFavorite from '@/components/ToggleFavourite';
import BatteryState from '@/components/device-states/BatteryState';
import ObjectStatuses from '@/components/device-states/ObjectStatuses';
import useAuth from '@/api/auth';
import { EventBus } from '@/utils/eventBus';
import NestedTable from '@/components/appTable/nestedTable.vue';

export default {
  name: 'appTable',
  components: {
    NestedTable,
    ObjectStatuses,
    BatteryState,
    ToggleFavorite,
    AvatarItem
  },
  props: {
    showMobile: {
      type: [Boolean],
      default: false
    },
    columns: {
      type: [Array],
      required: true
    },
    items: {
      type: [Array],
      required: true
    },
    total: {
      type: [Number]
    },
    value: {
      type: [Array],
      default: () => []
    },
    loading: {
      type: [Boolean],
      default: false
    },
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      selected: [],
      isFired: false,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      timerDate: 0,
      pagination: {
        rowsPerPage: 10
      },
      expanded: [],
      profile: useAuth()
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    expandItem(item) {
      if (this.expanded.map(i => i.id).includes(item.id)) {
        this.expanded = this.expanded.filter(i => i.id !== item.id);
      } else {
        this.expanded.push(item);
      }
    },
    truncateString,
    openItem(item) {
      if (this.selected.length === 0) {
        this.$emit('setActive', item);
      }
    },
    handlerRow(e) {
      this.$emit('setActive', e);
    },
    setSelected(item) {
      const ids = this.selected.map(i => i.id);
      if (ids.includes(item.id)) {
        this.selected = this.selected.filter(i => i.id !== item.id); //.splice(ids.indexOf(item.id), 1);
      } else {
        this.selected.push(item);
      }
    },
    update(v) {
      if (!this.isFired) {
        this.isFired = true;
      } else {
        this.$emit('update', v);
      }
    },
    checkAvatar(v) {
      return v.indexOf('mdi') > -1 ? 'icon' : 'avatar';
    },
    handleSelect(item) {
      this.selected.push(item);
    },
    valueComparator(a, b) {
      return a.id === b.id;
    },
    getBatteryLvL(v) {
      if (v.deviceBatteryType) {
        return 100;
      }
      if (
        v.deviceBatteryType === undefined ||
        v.deviceBatteryType === '' ||
        !v
      ) {
        return 0;
      }
      return Number(v.deviceBatteryLevel);
    },
    getLetters(v) {
      return v
        .split(' ')
        .map(i => i[0])
        .join('');
    }
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    selected: {
      handler() {
        this.$emit('input', this.selected);
      },
      deep: true
    },
    filter(value) {
      this.sortBy = value.sort[0];
      this.sortDesc = Boolean(value.desc.length);
    }
  },
  mounted() {
    EventBus.$on('reset-pagination', e => {
      this.options.page = 1;
    });

    const programNumbersOfRows = this.profile.profile.value?.objectProperties.find(
      item => item.key === 'programNumbersOfRows'
    )?.value;

    if (programNumbersOfRows) {
      this.pagination.rowsPerPage = programNumbersOfRows;
      this.options.itemsPerPage = programNumbersOfRows;
    }
  },
  created() {
    this.selected = this.value;
  }
};
</script>

<style lang="sass">
.custom-table > .v-data-table__wrapper
  height: calc(100dvh - (64px * 3))
  overflow-y: scroll

.custom-table__row
  position: relative

.custom-table tr
  height: 56px

.custom-table thead th
  font-size: 16px !important

.selected-row
  background: #eeeeee

.table-button-context
  position: absolute
  right: 10px
  top: 5px

.avatar_text
  display: flex
  align-items: center
  justify-content: center
  width: inherit
  height: inherit

.red_text
  color: #D50000

.v-data-footer
  flex-wrap: nowrap

.theme--dark .active-row
  background: #616161

.theme--light .active-row
  background: #eeeeee


.theme--dark .active-row-nested
  background: #c0eeff

.theme--light .active-row-nested
  background: #c0eeff

.nestedCell
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important


th, td
  white-space: nowrap

.mobile-table
  height: calc(100dvh - 123px)
  display: flex
  flex-direction: column
  justify-content: space-between

.mobile_list
  max-height: calc(100dvh - 181px)
  overflow-y: auto
</style>

<style lang="scss">
.nameColumn {
  position: relative;
}

.nestedIndicator {
  border-left: 1px dotted gray;
  width: 40px;
  height: 29px;
  position: absolute;
  top: 39px;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    bottom: 0;
    border-bottom: 1px dotted gray;
  }
}
</style>
